import styled from '@emotion/styled'

export const FeaturesList = styled.ul`
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spaces.space4};
	margin: ${({ theme }) => theme.spaces.space0};
	padding: ${({ theme }) => theme.spaces.space0};
`

export const FeatureItem = styled.li`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: ${({ theme }) => theme.spaces.space4};
	${({ theme }) => theme.typography.caption};
`

export const FeatureExplanation = styled.p`
	${({ theme }) => theme.typography.caption};
	color: ${({ theme }) => theme.colors.light.grayscale[550]};
	margin-top: ${({ theme }) => theme.spaces.space0};
	margin-bottom: ${({ theme }) => theme.spaces.space7};
`
